import React, { memo, useCallback } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { Minus, Plus, X } from "lucide-react";

function CartItems({ item }) {
  const { updateQuantity, removeItem } = useCart();

  const {
    _id,
    thumbnail: image,
    slug,
    title,
    variantName,
    quantity,
    price,
    mrp,
  } = item;

  const numPrice = Number(price);
  const numMrp = Number(mrp);

  const handleRemove = useCallback(() => {
    removeItem(_id);
  }, [removeItem, _id]);

  const handleQuantityChange = useCallback(
    (delta) => {
      const newQuantity = quantity + delta;
      if (newQuantity < 1) return;

      console.log(newQuantity);
      updateQuantity(_id, newQuantity);
    },
    [updateQuantity, _id, quantity],
  );

  return (
    <>
      <div className="d-flex align-items-center mb-4 position-relative fade-in">
        {/* <img src={item.image} className="cart-item-img" width="80" height="80" style={{objectFit: 'cover'}} alt={item.name} /> */}

        <Link to={slug}>
          {/* <img src={image} alt="Cart Item" /> */}
          <img
            src={image}
            className="cart-item-img"
            width="80"
            height="80"
            style={{ objectFit: "contain" }}
            alt="Cart Item"
          />
        </Link>

        <div className="ms-3 flex-grow-1">
          {/* <small className="text-muted text-uppercase" style={{fontSize: '0.65rem'}}>{item.category}</small> */}

          {/* <Link to={slug} >
             <small >{title}</small>
          </Link> */}

          <Link
            to={slug}
            className="cart-offcanvas-title link text-md fw-medium"
          >
            {title}
          </Link>

          <div className="info-variant">{variantName}</div>
          {/* <h6 className="mb-1" style={{fontFamily: 'var(--font-serif)'}}>{item.name}</h6> */}
          {/* <span className="text-secondary fw-bold">Rs.{item.price}</span> */}

          <span className="text-secondary fw-bold">
            ₹{numPrice.toFixed(2)}/-
          </span>

           <div className="d-flex">
            <div className="custom-cart-qty-toggle">
              <Minus
                size={12}
                className="pointer custom-plus-icon"
                onClick={() => handleQuantityChange(-1)}
              />
               <input
               
                type="number"
                value={quantity}
                readOnly
              />
              <Plus
                size={12}
                className="pointer custom-plus-icon"
                onClick={() => handleQuantityChange(+1)}
              />
            </div>
            {/* <div className="qty-pill">
              <button
                className="qty-btn"
                onClick={() => handleQuantityChange(-1)}
              >
                -
              </button>
              <input
                className="quantity-product font-4"
                type="number"
                value={quantity}
                readOnly
              />
              <button
                className="qty-btn"
                onClick={() => handleQuantityChange(+1)}
              >
                +
              </button>
            </div> */}
            {/* <span className="new-price text-primary fw-medium p-2">
              ₹{(price * quantity).toFixed(2)}/-
            </span> */}
          </div>
        </div>
        <button onClick={handleRemove} className="icon-btn text-muted">
          <X size={16} />
        </button>
      </div>
    </>
  );
}

export default memo(CartItems);
